import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import API from "../../config/config";
import { connect } from "react-redux";
import httpService from "../../services/httpService";
import appService from "../../services/appService";
import { formatCurrency } from "../../helpers/utils";
import { eventAddToCart } from "../../helpers/events";
import Link from "next/link";

const ProductListing = ({
  data,
  status,
  cart,
  onToggle,
  setCartItems,
  col,
  showLoader,
  hideLoader,
}: any) => {
  const prodMinMax = (item: any) => {
    let min: any = [];
    if (item.price !== null) {
      return formatCurrency(Math.abs(item.price).toFixed(2));
    } else {
      item.ProductVariant[0].Variants.map((items: any, i: number) => {
        if (items.newPrice) {
          min.push(items.newPrice);
          return null;
        } else {
          min.push(items.price);
          return null;
        }
      });
      const mi = Math.min(...min);
      const ma = Math.max(...min);
      return `${formatCurrency(Math.abs(mi).toFixed(2))} - ${formatCurrency(
        Math.abs(ma).toFixed(2)
      )}`;
    }
  };

  const GoogleAnalyticsAddToCart = (item: any) => {
    let prod = {};
    if (item.product_categories && item.product_categories.length > 0) {
      let category = "";
      item.product_categories.forEach((element: any, i: number) => {
        if (element.name) {
          category += element.name;
          if (i < item.product_categories.length) {
            category += "/";
          }
        }
      });
      prod = { ...prod, category: category };
    }
    prod = {
      ...prod,
      id: item.id,
      name: item.displayTitle ? item.displayTitle : item.title,
      discount: item.newPrice !== null ? item.price - item.newPrice : 0,
      affiliation: "Nexersys Store",
      brand: "Nexersys",
      // item_category: 'pants',
      // item_variant: 'black',
      price: item.newPrice !== null ? item.newPrice : item.price,
      currency: item.currency ? item.currency.code : "USD",
      quantity: 1,
    };
    const data = {
      currency: "USD",
      items: [prod],
      value: item.newPrice !== null ? item.newPrice : item.price,
    };
    eventAddToCart(data);
  };

  const addToCart = (id: number) => {
    const cartid = appService.getKey("cartid");
    // setLoad(id);
    showLoader();
    httpService.invokeApi(
      {
        url: `${API.endpoints.getCart}/${cartid}/cartitems`,
        method: "put",
        data: {
          productId: id,
          quantity: 1,
        },
      },
      (success: boolean, res: any) => {
        if (success && res.id) {
          const request: any = { method: "get", url: API.endpoints.getCart };
          if (cartid) {
            request.headers = { cartid: cartid };
          }
          httpService.invokeApi(request, (success: boolean, resp: any) => {
            if (success && resp.cartId) {
              appService.setKey("cartid", resp.cartId);
              setCartItems(resp);
              //setLoad(0);
              onToggle();
              hideLoader();
            } else {
              hideLoader();
            }
          });
        } else {
          hideLoader();
        }
      }
    );
  };

  const getImage = (item: any) => {
    let imageUrl: string = "";
    if (item.image) {
      imageUrl = API.baseUrl + item.image.url;
    } else {
      if (item.ProductVariant && item.ProductVariant.length) {
        if (item.ProductVariant[0].Variants[0].images[0]) {
          if (item.ProductVariant[0].Variants.length) {
            if (item.ProductVariant[0].Variants[0].images[0]) {
              imageUrl =
                API.baseUrl + item.ProductVariant[0].Variants[0].images[0].url;
            }
          }
        }
      }
    }
    return imageUrl;
  };

  const onSale = (item: any) => {
    if (item.newPrice) {
      return true;
    } else {
      if (item.ProductVariant.length > 0) {
        return item.ProductVariant[0].Variants.find(
          (items: any, i: number) => items.newPrice !== null
        );
      }
      return false;
    }
  };
  return (
    <Container className="product-listing-container">
      <Row xl={col} lg={3} xs={1} sm={2} md={2}>
        {data.map((item: any, i: number) => {
          return (
            <Col key={i}>
              <div className="product-container card">
                {item.CustomLink ? (
                  <Link href={`${item.CustomLink.url}`}>
                    <a className="product-navigator">
                      <div
                        className="product-image"
                        style={{ backgroundImage: `url(${getImage(item)})` }}
                      />
                      {onSale(item) && <span>sale</span>}
                      <p className="pro-title">{item.displayTitle}</p>
                    </a>
                  </Link>
                ) : (
                  <a
                    href={`/${API.product}/${item.slug}`}
                    className="product-navigator"
                  >
                    <div
                      className="product-image"
                      style={{ backgroundImage: `url(${getImage(item)})` }}
                    />
                    {onSale(item) && <span>sale</span>}
                    <p className="pro-title">{item.displayTitle}</p>
                  </a>
                )}
                <p className="pro-price">
                  {item.currency.symbol}
                  {prodMinMax(item)}
                </p>
                {item.CustomLink ? (
                  <Link href={`${item.CustomLink.url}`}>
                    <a className="pro-button">{item.CustomLink.text}</a>
                  </Link>
                ) : item.ProductVariant.length > 0 ? (
                  <Link href={`/product/${item.slug}`}>
                    <a className="pro-button">select option</a>
                  </Link>
                ) : (
                  <div
                    className="pro-button"
                    onClick={() => {
                      addToCart(item.id);
                      GoogleAnalyticsAddToCart(item);
                    }}
                  >
                    Add to cart
                    {/* {load === item.id && <i className="fas fa-spinner fa-pulse" />} */}
                  </div>
                )}
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart,
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: "TOGGLE_CART" }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: "ON_CART_LOAD", payload: cartItems });
    },
    showLoader: () => dispatch({ type: "LOADER_SHOW" }),
    hideLoader: () => dispatch({ type: "LOADER_HIDE" }),
  };
};

export default connect(mapState, mapDispatch)(ProductListing);
